<div class="flex flex-col gap-6 p-7">
  <div>
    <h2>Configura tu encuadernado</h2>
    <app-binding-options
      [settings]="settings"
      [printProduct]="printProduct"
      [qty]="printProduct.qty"
      [file]="file"
      [isModal]="isModal"
      (optionSelect)="optionSelect($event)"
      [additionalClasses]="{ 'general-selected': true }"
    >
    </app-binding-options>
  </div>
  <div class="w-100 flex flex-row gap-1.5">
    <ion-button color="medium-dark" fill="outline" (click)="cancel()">Cancelar</ion-button>
    <ion-button fxFlex (click)="submit()">Guardar y continuar</ion-button>
  </div>
</div>
